<template>
  <div class="container-income-details">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <div class="nav-bar-left">
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
            <span class="tit-left">{{ $t('lang.BaseCommon.k033') }}</span>
          </div>
        </template>
      </van-nav-bar>
    </div>

    <div class="income-details">
      <div class="filter-box">
        <div class="select-time" @click="openTimePop">
          <span>{{ handleMoment(chooseTime, 'YYYY-MM-DD') }}</span>
          <img src="@/assets/packageAssets/common/arrow06.webp" alt="" />
        </div>
        <!-- 选择 -->
        <div class="select-type" @click="openSeletePop">
          {{ activeStatu }}
          <img src="@/assets/packageAssets/common/arrow06.webp" alt="" />
        </div>
      </div>
      <!-- <div class="income-list" @scroll="fetchMyBeansDetail"> -->
      <van-list
        class="income-list"
        v-model="isLoading"
        loading-text=" "
        :immediate-check="false"
        :finished="isEnd"
        :finished-text="''"
        :offset="300"
        @load="fetchMyBeansDetail"
      >
        <div v-for="(item, index) in data" :key="getBillItemKey(item, index)">
          <div class="list-item" :class="{ 'active-color': item.tip }" @click="handleToggleTip(item, index)">
            <div class="list-item-left">
              <div class="bill-type">{{ findBillTypeTxt(item.billType) }}</div>
              <div class="bill-time">{{ handleMoment(item.createTime, 'YYYY-MM-DD HH:mm:ss') }}</div>
            </div>
            <div class="list-item-right">
              <div class="bill-content">
                <div class="bill-beans">
                  <img v-show="item.tip" class="bill-q" src="@/assets/packageAssets/views/P1_Girls/MyBeans/default/question.webp" alt="" />
                  {{ item.changeAmount > 0 ? '+' + item.changeAmount : item.changeAmount }}
                  <img class="bill-b" :src="getMatchImg('beans')" alt="" />
                </div>
                <div class="bill-from">{{ item.fromName }}</div>
              </div>
              <img
                v-show="item.tip"
                class="bill-arrow"
                :class="{ 'arrow-down': !item.tipShow }"
                src="@/assets/packageAssets/common/arrow08.webp"
                alt=""
              />
            </div>
          </div>
          <div v-show="item.tipShow" class="tips-item">
            <p class="tips-tit">{{ $t('lang.BaseCommon.k033') }}</p>
            <p class="tips-text">{{ item.tip }}</p>
          </div>
        </div>
      </van-list>
      <!-- </div> -->
    </div>
    <CTimeDay :showPop="showPop" @handleCurrentDate="handleCurrentDate" />
    <Selete :defaultIndex="defaultIndex" :columns="incomeType" :showPop="showSelete" @currentChoose="handleCurrentSelete" />
  </div>
</template>

<script>
// 这是主播代理income derails
import CTimeDay from '@/components/CTimeDay'
import Selete from '@/components/CSelete/Selete'
import { apiFetchMyBeansDetail } from '@/api/imee'
export default {
  components: { CTimeDay, Selete },
  props: {},
  data() {
    return {
      showSelete: false,
      activeStatu: this.$t('lang.BaseCommon.k003'), // 默认状态
      incomeType: [
        {
          id: '',
          idArr: [],
          text: this.$t('lang.BaseCommon.k003'),
        },
        {
          id: '2,37',
          idArr: [2, 37],
          text: this.$t('lang.BaseCommon.k075'),
        },
        {
          id: '3,17',
          idArr: [3, 17],
          text: this.$t('lang.BaseCommon.k080'),
        },
        {
          id: '5,26',
          idArr: [5, 26],
          text: this.$t('lang.BaseCommon.k077'),
        },
        {
          id: '6,37,1,4,7,8,9,10,11,12,13,14,19,20,23,30,31,32,33,34',
          idArr: [6, 1, 4, 7, 8, 9, 10, 11, 12, 13, 14, 19, 20, 23, 30, 31, 32, 33, 34],
          text: this.$t('lang.BaseCommon.k079'),
        },
        {
          id: '15',
          idArr: [15],
          text: this.$t('lang.BaseCommon.k078'),
        },

        {
          id: '16,21,27,22,24,25,28,29,35,36,38,39,40',
          idArr: [16, 21, 27, 22, 24, 25, 28, 29, 35, 36, 38, 39, 40],
          text: this.$t('lang.BaseCommon.k073'),
        },

        {
          id: '18',
          idArr: [18],
          text: this.$t('lang.BaseCommon.k082'),
        },
      ],
      showPop: false,
      defaultIndex: 0,
      chooseTime: new Date(),
      listQuery: {
        limit: 20,
        offsetId: null,
      },
      billTypes: '',
      data: [],
      isEnd: false,
      isLoading: false,
    }
  },
  methods: {
    getBillItemKey(item, index) {
      if (item && item.id != null) {
        return item.id
      }
      return `bill-${index}-${item && item.createTime != null ? item.createTime : ''}`
    },

    removeEmptyValues(obj) {
      return Object.keys(obj).reduce((acc, key) => {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '' && !(typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0)) {
          acc[key] = obj[key]
        }
        return acc
      }, {})
    },

    // 返回当天的零点到23点59的时间戳
    getZeroToTwentyThree(chooseTime) {
      const date = new Date(chooseTime)
      const year = date.getFullYear()
      const month = date.getMonth()
      const day = date.getDate()
      const hour = 0
      const minute = 0
      const second = 0
      const startTime = new Date(year, month, day, hour, minute, second).getTime()
      const endTime = new Date(year, month, day, 23, 59, 59).getTime()
      return {
        startTime: startTime,
        endTime: endTime,
      }
    },

    findBillTypeTxt(billType) {
      const tempObj = this.incomeType.find((item) => item.idArr.includes(billType))
      return tempObj ? tempObj.text : ''
    },

    // 打开日期弹框
    openTimePop() {
      this.showPop = true
    },

    // 关闭日期弹框
    closePop() {
      this.showPop = false
    },

    // 确认日期
    handleCurrentDate(val) {
      this.data.length = 0
      this.listQuery.offsetId = ''
      this.isEnd = false
      this.chooseTime = val
      this.fetchMyBeansDetail()
    },

    // 打开状态弹框
    openSeletePop() {
      this.showSelete = true
    },

    // 关掉状态弹框
    closeSeletePop() {
      this.showSelete = false
    },

    // 确认状态
    handleCurrentSelete(val) {
      this.isEnd = false
      this.data.length = 0
      this.listQuery.offsetId = ''
      this.activeStatu = val.text
      this.showSelete = false
      // 无状态
      if (!val.id) {
        this.billTypes = null
        this.fetchMyBeansDetail()
      }
      // 有状态
      else {
        this.billTypes = val.id
        this.fetchMyBeansDetail()
      }
    },

    // 获取详情数据
    fetchMyBeansDetail() {
      const params = {
        ...this.listQuery,
        ...this.getZeroToTwentyThree(this.chooseTime),
        walletType: 0,
        billTypes: this.billTypes,
      }
      const newParams = this.removeEmptyValues(params)
      this.isLoading = true
      apiFetchMyBeansDetail(newParams)
        .then((resData) => {
          // todo-模拟数据-调试
          // resData = [
          //   {
          //     billType: 1,
          //     changeAmount: 100,
          //     createTime: 1630300800000,
          //     fromName: 'DQ',
          //     tip: 'DQ'
          //   }
          // ]
          if (resData && !resData.error) {
            if (resData.length) {
              resData.forEach((incomeItem) => {
                if (incomeItem.tip) {
                  incomeItem.tipShow = false
                }
              })
            }

            this.data = this.data.concat(resData)

            this.isLoading = false
            // 最后一页
            if (resData.length < this.listQuery.limit) {
              this.isEnd = true
            }
            // 非最后一页
            else {
              this.isEnd = false
              if (resData.length > 0) {
                this.listQuery.offsetId = Math.min.apply(
                  Math,
                  resData.map(function (item) {
                    return item.id
                  })
                )
              }
            }
          }
          // 没有数据
          else {
            this.isLoading = false
            this.isEnd = true
          }
        })
        .catch((err) => {
          this.isLoading = false
          this.isEnd = true
        })
    },
    handleToggleTip(item, index) {
      if (item.tip) {
        item.tipShow = !item.tipShow
      }
    },
  },
  created() {
    this.fetchMyBeansDetail()
  },
}
</script>
<style lang="scss" scoped>
.container-income-details {
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  // 导航栏
  .nav-bar-left {
    display: flex;
    font-family: 'Outfit-Bold';
    font-size: 0;

    .left-nav {
      width: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: middle;
    }
    .tit-left {
      display: inline-block;
      vertical-align: middle;
      font-weight: bold;
      font-size: 22px;
      color: #000000;
      margin-left: 4px;
    }
  }

  .income-details {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .filter-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 60px;
      background: #f2f4f7;
      padding: 0 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      .select-time {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        border-radius: 6px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        font-family: 'Inter-Medium', 'Inter-Regular';
        font-weight: 500;
        color: #999999;
        padding-right: 24px;
        > img {
          position: absolute;
          right: 4px;
          width: 16px;
        }
      }
      .select-type {
        position: relative;
        min-width: 130px;
        padding: 0 24px 0 16px;
        height: 30px;
        border-radius: 6px;
        text-align: right;
        line-height: 30px;
        font-size: 14px;
        font-family: 'Inter-Medium', 'Inter-Regular';
        font-weight: 500;
        color: #999999;
        > img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 4px;
          width: 16px;
        }
      }
    }
    .income-list {
      flex: 1;
      width: 100%;
      overflow: scroll;
      padding-bottom: 20px;
      .list-item {
        width: 100%;
        padding: 16px;
        display: flex;
        font-family: 'Inter-Regular';
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 17px;
        font-style: normal;
        .list-item-left {
          flex: 1;
          font-size: 14px;
          padding-top: 3px;

          .bill-type {
            color: #222222;
            font-family: 'Outfit-Bold';
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            min-height: 24px;
            line-height: 24px;
          }

          .bill-time {
            font-family: 'Outfit-Bold';
            font-size: 12px;
            min-height: 18px;
            line-height: 18px;
            color: #999999;
          }
        }
        .list-item-right {
          display: flex;
          align-items: center;
          .bill-content {
            .bill-beans {
              display: flex;
              align-items: center;
              justify-content: flex-end;

              color: #222222;
              font-family: 'Outfit-Bold';
              font-size: 20px;
              font-style: normal;
              font-weight: 500;
              line-height: 30px;

              .bill-q {
                width: 20px;
                height: 20px;
                margin-right: 4px;
              }

              .bill-b {
                width: 14px;
                height: 14px;
                margin-left: 4px;
              }
            }

            .bill-from {
              color: #999999;
              font-family: 'Outfit-Bold';
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px;
              text-align: right;
            }
          }

          .bill-arrow {
            width: 28px;
            height: 28px;
            &.arrow-down {
              transform: rotateX(180deg);
            }
          }
        }
      }

      .tips-item {
        padding: 8px 16px;
        background-color: #ffefd5;
        .tips-tit {
          color: #ff7f2d;
          font-family: 'Outfit-Bold';
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px;
        }
        .tips-text {
          color: #7a1908;
          font-family: 'Outfit-Bold';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
        }
      }
    }
  }
}

.active-color {
  background-color: #faf8f7;
}
</style>
